import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { qrLogoTypeBackground } from "../../../../../redux/slices/qrSettings";
import { useDebounce } from "use-debounce";
import Form from "react-bootstrap/Form";

function LogoBackgroudToggle() {
  const lang = useSelector((state) => state.changeLang.language.stepThree.logo);
  const logotypeBackground = useSelector(
    (state) => state.qrSettings.logotypeBackground
  );

  const dispatch = useDispatch();
  const [logoBackground, setLogoBackground] = useState(logotypeBackground);
  const [value] = useDebounce(logoBackground, 100);
  useEffect(() => {
    setLogoBackground(logotypeBackground);
  }, [logotypeBackground]);
  useEffect(() => {
    dispatch(qrLogoTypeBackground(value));
  }, [value]);

  return (
    <Form.Check
      type="switch"
      id="custom-switch"
      className="text-capitalize"
      label={lang[1]}
      checked={logoBackground}
      onChange={() => setLogoBackground(!logoBackground)}
    />
  );
}

export default LogoBackgroudToggle;
